import { Component } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

interface ICloseAccountModalContext {
  account: any;
}
@Component({
  selector: 'app-close-account-modal',
  templateUrl: './close-account-modal.component.html',
  styleUrls: ['./close-account-modal.component.scss'],
})
export class CloseAccountModalComponent {
  error: any;
  success: any;
  pending = false;
  deactivated = false;

  constructor(
    public modal: SuiModal<ICloseAccountModalContext, any, any>,
    private walletService: EwalletService
  ) {}
  formatAmount(amount: number) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  deactivateAccount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const payload = {
      nccId: this.modal.context.account.nccId,
      currencyId: this.modal.context.account.currencyId,
      // createdBy: {appUserId: user.appUserId, username: user.username, name: user.firstName},
      // accountDetails: this.modal.context.account.activeBankDetails
    };
    this.pending = true;
    this.walletService.deactivateAccountCurrency({ body: payload }).subscribe(
      (res) => {
        this.pending = false;
        this.deactivated = true;
        this.success = 'Account Closed';
        setTimeout(() => {
          this.closeModal();
        }, 1500)
      },
      (err) => {
        this.pending = false;
        this.error = err.error;
      }
    );
  }

  closeModal() {
    if (this.deactivated) {
      this.modal.approve(true);
    } else {
      this.modal.deny(false);
    }
  }
}

export class CloseAccountModal extends ComponentModalConfig<
  ICloseAccountModalContext,
  any,
  any
> {
  constructor(account: any, size: ModalSize = ModalSize.Tiny) {
    super(CloseAccountModalComponent, { account });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
